const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']

// "Sábado 6 de junio"; la fecha de la salida llega como ISO o como ms.
export const fechaTexto = (fecha) => {
  if (fecha == null || fecha === '') return ''
  const d = new Date(typeof fecha === 'string' && /^\d+$/.test(fecha) ? Number(fecha) : fecha)
  if (isNaN(d)) return ''
  return `${DIAS[d.getDay()]} ${d.toLocaleDateString('es-AR', { day: 'numeric', month: 'long' })}`
}

export const cantidadSalidas = (n) =>
  n === 1 ? '1 salida para informar' : `${n} salidas para informar`
